import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EmployeeSidebar from '../components/EmployeeSidebar';
import EmployeeShiftView from '../components/EmployeeShiftView';
import EmployeeImageUpload from '../components/EmployeeImageUpload';
import EmployeeCheckIn from '../components/EmployeeCheckIn';
// import EmployeeCashbox from '../components/EmployeeCashbox';
 import EmployeeTodoList from '../components/EmployeeTodoList';
import employeeAuthService from '../services/employee-auth.service';
import './EmployeeDashboardPage.css';
import EmployeeAvailability from '../components/EmployeeAvailability';

const EmployeeDashboardPage = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('shifts');
  const [employee, setEmployee] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Authentication check
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if employee is authenticated using the employee auth service
        if (!employeeAuthService.isLoggedIn()) {
          navigate('/employee/login');
          return;
        }
        
        // Get employee information from auth service
        const userData = employeeAuthService.getUser();
        setEmployee({
          name: userData.name || userData.username || 'Çalışan',
          role: userData.role
        });
      } catch (error) {
        console.error('Authentication check error:', error);
        navigate('/employee/login');
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogout = () => {
    // Use employee auth service for logout
    employeeAuthService.logout();
    navigate('/employee/login');
  };

  const renderActiveComponent = () => {
    switch (activeSection) {
      case 'shifts':
        return <EmployeeShiftView employeeId={employee?.id} />;
      case 'upload':
        return <EmployeeImageUpload />;
      case 'checkin':
        return <EmployeeCheckIn employeeId={employee?.id} />;
      case 'availability':
        return <EmployeeAvailability />;
      case 'todos':
        return <EmployeeTodoList employeeId={employee?.id} />;
      default:
        return <EmployeeShiftView employeeId={employee?.id} />;
    }
  };

  if (isLoading) {
    return <div className="employee-loading-screen">Yükleniyor...</div>;
  }

  return (
    <div className="employee-dashboard">
      <EmployeeSidebar 
        activeSection={activeSection} 
        setActiveSection={setActiveSection} 
        onLogout={handleLogout}
        employeeName={employee?.name}
      />
      <main className="employee-dashboard-content">
        {renderActiveComponent()}
      </main>
    </div>
  );
};

export default EmployeeDashboardPage;